<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import OcupationalMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalMedicineAPI";
import CheckModal from "@/components/CheckModal";
import Pagination from "@/components/standard/OcupationalMedicine/OcupationalPagination";
import DontExist from "@/components/company/components/DontExist";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.4-1 Formato comunicación al trabajador ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    Pagination,
    DontExist,
  },
  data() {
    return {
      title: "3.1.4-1 Formato comunicación al trabajador",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Realización de los exámenes médicos ocupacionales",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/medicina-ocupacional`,
        },
        {
          text: "Formato comunicación al trabajador",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],

      item: null,
      itemStatus: null,

      searchEmail: null,
      email: null,

      itemData: null,

      file: null,
      company: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id ||
        null,
      user: this.$store.state.auth || null,

      loading1: true,

      search: "",
      loading: true,

    };
  },
  methods: {

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getList() {
      OcupationalMedicineAPI.getAllMedicineCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          let medicine = response.Ocupational_medical.data;
          this.lista = medicine;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    getEmail() {
      OcupationalMedicineAPI.getEmail({
        search: this.searchEmail,
      })
        .then((response) => {
          this.email = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },


  },

  mounted() {
    this.getUsers();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1 && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <h4 class="form-group px-4">
                Formato comunicación al trabajador
              </h4>

              <form class="form-group px-4" @submit.prevent="getEmail">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Seleccione un empleado">
                    <select required class="form-control" @click="getEmail()" v-model="searchEmail">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.full_name">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                </div>

                <div v-if="this.searchEmail === null" class="form-row pt-3 px-2">
                  <p>No se ha buscado un empleado</p>
                </div>
                <div v-else class="form-row pt-3 px-2">
                  <p class="col-12">Fecha: {{ this.email.date }}</p>
                  <p class="col-12 pt-2">Estimado(a)</p>
                  <p class="col-12">{{ this.email.employee }}</p>

                  <p class="col-12 pt-3">
                    Adjunto encontrará el resumen de la Evaluación médica
                    ocupacional.
                  </p>

                  <p class="col-12">
                    Dentro de las restricciones y/o recomendaciones se
                    encuentran:
                  </p>

                  <ul v-if="this.email.data.length > 0">
                    <li class="px-2" v-for="dato in this.email.data">
                      {{ dato }}
                    </li>
                  </ul>
                  <p v-else class="col-12">
                    El empleado no tiene restricciones y/o recomendaciones
                  </p>

                  <p class="col-12 pt-2">Atentamente,</p>
                  <p class="col-12">Gestión Humana</p>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else-if="!loading1 && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading1">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
